import React from 'react';
import { motion } from 'framer-motion';
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './tic-tac-toe-app.css';
import ticTacToeImage from '../../../assets/images/tic-tac-toe App Image.png';

const TicTacToeApp = () => {
  return (
    <motion.div
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Tic-<span>Tac-Toe App</span>
      </motion.h1>

      <motion.p
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
        Last Updated On: 19th October 2025
      </motion.p>

      <div className="project-content">
        <motion.div
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={ticTacToeImage} alt="Tic Tac Toe Game" className="project-image" />
          <h2 className="project-subtitle">Tic-Tac-Toe Game</h2>
          <span className="project-category">Mini Project</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="ticTacToe" trackView={true} />

          {/* Buttons */}
          <div className="project-buttons">
            <a
              href="https://tic-tac-toe-online-web.netlify.app/"
              className="visit-project-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              → Visit the Project
            </a>
            <a
              href="https://github.com/Praveenkumar-king/tic-tac-toe-app"
              className="visit-project-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "ticTacToe",
                title: "Tic-Tac-Toe App",
                path: "/projects/projectdetail/tic-tac-toe-app"
              }}
            />
          </div>
        </motion.div>

        <motion.div
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Project Details</h3>
          <p className="overview-text">
            Welcome to the <strong>Tic-Tac-Toe Game</strong> — a fun, interactive, and animated React project where two players can compete to get three in a row!
          </p>

          <h3 className="section-title">Overview 🎮</h3>
          <p className="overview-description">
            This game allows two players to play Tic-Tac-Toe in the browser with smooth animations and a clean UI built using <strong>React</strong> and <strong>Framer Motion</strong>.
          </p>

          <h3 className="section-title">Key Features 🧩</h3>
          <ul className="feature-list">
            <li><strong>Interactive Gameplay</strong> 🎯 - Players take turns placing X and O on the grid.</li>
            <li><strong>Winner Detection</strong> 🏆 - Highlights the winning combination instantly.</li>
            <li><strong>Restart Option</strong> 🔄 - Reset and start a new match anytime.</li>
            <li><strong>Animations</strong> ✨ - Smooth entry, hover, and win animations for a fun experience.</li>
            <li><strong>Responsive Design</strong> 📱 - Play on mobile, tablet, or desktop with ease.</li>
          </ul>

          <h3 className="section-title">How It Works ⚙️</h3>
          <ul className="how-it-works-list">
            <li><strong>Click to Play</strong> 🖱️ - Players alternate between X and O on the 3×3 grid.</li>
            <li><strong>Check Winner</strong> 🏁 - The game automatically checks for a winner or draw.</li>
            <li><strong>Reset Game</strong> 🔁 - Use the “Restart” button to begin a fresh match.</li>
          </ul>

          <h3 className="section-title">Technical Details 💻</h3>
          <ul className="technical-details-list">
            <li><strong>Frontend</strong> - Built using <strong>React.js</strong> and styled with CSS animations.</li>
            <li><strong>Animations</strong> - Powered by <strong>Framer Motion</strong> for a smooth user experience.</li>
            <li><strong>Logic</strong> - Game logic implemented using React’s <code>useState</code> and <code>useEffect</code>.</li>
          </ul>

          <h3 className="section-title">Future Improvements 🚀</h3>
          <ul className="future-features-list">
            <li><strong>AI Mode</strong> 🤖 - Add a single-player mode with computer opponent.</li>
            <li><strong>Scoreboard</strong> 🧮 - Track the score of each player.</li>
            <li><strong>Sound Effects</strong> 🔊 - Add sounds for moves and winning moments.</li>
          </ul>

          <h3 className="section-title">Conclusion 🏁</h3>
          <p>
            The <strong>Tic-Tac-Toe Game</strong> is a simple yet enjoyable project that demonstrates interactive UI design, animations, and game logic using React. Perfect for learning and showcasing frontend development skills!
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default TicTacToeApp;
